module.exports = __webpack_public_path__ + "static/img/fight.515132ab.png";